import { FC } from "react";
import styles from './product-short-info.module.scss';
import { Select } from "../../forms";

export type ShortInfoRentalStationSelectProps = {
  rentalStationsOptions: {
    key: string;
    value: string;
    name: string;
    description: string;
  }[];
  onRentalStationChanged: (id: string) => void;
  selectedRentalStationId: string | undefined;
}

export const ShortInfoRentalStationSelect: FC<ShortInfoRentalStationSelectProps> = ({
  rentalStationsOptions,
  onRentalStationChanged,
  selectedRentalStationId
}) => {
  return (
    <div className={styles.rentalStationInfo}>
      <Select
        id={'rentalStation-select'}
        name={'rentalStation-select'}
        options={rentalStationsOptions}
        onChange={onRentalStationChanged}
        defaultValue={selectedRentalStationId ?? undefined}
        noOptionsText={''}
        noSelectionText={''}
      />
    </div>
  );
};